import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoRoutingModule } from './demo-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { DemoCalendarComponent } from './pages/calendar/calendar.component';
import { DemoDashboardComponent } from './pages/dashboard/dashboard.component';
import { DemoGXComponent } from './pages/gx/gx.component';
import { DemoInboxComponent } from './pages/inbox/inbox.component';
import { DemoOperationsComponent } from './pages/operations/operations.component';
import { DemoDirectComponent } from './pages/direct/direct.component';
import { DemoMetricsComponent } from './pages/metrics/metrics.component';
import { DemoPropertiesComponent } from './pages/properties/properties.component';
import { IframeTrackerDirective } from './pages/inbox/iframe-tracker.directive';
import { DemoDevicesComponent } from './pages/demo-devices/demo-devices.component';
import { DemoStatementsComponent } from './pages/demo-statements/demo-statements.component';
import { DemoMyBusinessComponent } from './pages/demo-my-business/demo-my-business.component';

@NgModule({
  declarations: [
    DemoDashboardComponent,
    DemoInboxComponent,
    DemoCalendarComponent,
    DemoGXComponent,
    DemoOperationsComponent,
    DemoMetricsComponent,
    DemoDirectComponent,
    DemoPropertiesComponent,
    IframeTrackerDirective,
    DemoDevicesComponent,
    DemoStatementsComponent,
    DemoMyBusinessComponent,
  ],
  imports: [CommonModule, RouterModule, SharedModule, DemoRoutingModule],
})
export class DemoModule {}
